import Chart from 'chart.js/auto';
import * as _bootstrap from 'bootstrap';

var myDoughnut;

$('#nutritionalValuesModal').on('show.bs.modal', function (e) {
	var _clickedLink = e.relatedTarget;

	var _nvlNrg = $(_clickedLink).data('nvl-nrg');
	var _nvlFats = $(_clickedLink).data('nvl-fats');
	var _nvlSfats = $(_clickedLink).data('nvl-sfats');
	var _nvlCrb = $(_clickedLink).data('nvl-crb');
	var _nvlSgr = $(_clickedLink).data('nvl-sgr');
	var _nvlPrt = $(_clickedLink).data('nvl-prt');
	var _nvlSlt = $(_clickedLink).data('nvl-slt');
	var _nvlSod = $(_clickedLink).data('nvl-sod');
	var _nvlLabelFats = $(_clickedLink).data('label-fats');
	var _nvlLabelCarbs = $(_clickedLink).data('label-carbs');
	var _nvlLabelProt = $(_clickedLink).data('label-prot');
	var _nvlLabelSlt = $(_clickedLink).data('label-slt');
	var _nvlLabelSdm = $(_clickedLink).data('label-sdm');
	var _nvlLabelOther = $(_clickedLink).data('label-other');

	// energy
	$('#NvlNrg').html((_nvlNrg * 4.184).toFixed(0) + ' kJ / ' + _nvlNrg + ' Kcal');

	// fats
	$('#NvlFats').html(_nvlFats + ' g');

	// sfats
	$('#NvlSfats').html(_nvlSfats + ' g');

	// carbohydrates
	$('#NvlCrb').html(_nvlCrb + ' g');

	// sugar
	$('#NvlSgr').html(_nvlSgr + ' g');

	// protein
	$('#NvlPrt').html(_nvlPrt + ' g');

	// salt
	$('#NvlSlt').html(_nvlSlt + ' g');

	// sodium
	if (_nvlSod) {
		$('#NvlSodTR').show();
		$('#NvlSod').html(_nvlSod + ' g');
	}
	else {
		$('#NvlSodTR').hide();
	}

	// init chart
	var _totFats = GetGraphData(_nvlFats);
	var _totCrb = GetGraphData(_nvlCrb);
	var _totPrt = GetGraphData(_nvlPrt);
	var _totSlt = GetGraphData(_nvlSlt);
	var _totSod = GetGraphData(_nvlSod);

	var _other = (100.00 - _totFats - _totCrb - _totPrt - _totSlt - _totSod).toFixed(2);

	InitChart(_totFats, _totCrb, _totPrt, _totSlt, _totSod, _other, _nvlLabelFats, _nvlLabelCarbs, _nvlLabelProt, _nvlLabelSlt, _nvlLabelSdm, _nvlLabelOther);
});

function GetGraphData(InputString) {
	if (!InputString)
		return 0;

	return parseFloat(InputString.toString().replace("> ", "").replace("< ", "")).toFixed(2);
}

function InitChart(Fats, Carb, Prot, Salt, Sodium, Other, FatsLabel, CarbsLabel, ProtLabel, SaltLabel, sodiumLabel, otherLabel) {
	var _data = new Array();
	var _backgroundColors = new Array();
	var _labels = new Array();

	// fats
	_data.push(Fats);
	_backgroundColors.push('orange');
	_labels.push(FatsLabel);

	// carbohydrates
	_data.push(Carb);
	_backgroundColors.push('dodgerblue');
	_labels.push(CarbsLabel);

	// proteins
	_data.push(Prot);
	_backgroundColors.push('darkred');
	_labels.push(ProtLabel);

	// salt
	_data.push(Salt);
	_backgroundColors.push('#f174c1');
	_labels.push(SaltLabel);

	// sodium
	_data.push(Sodium);
	_backgroundColors.push('#6cc550');
	_labels.push(sodiumLabel);

	// other
	_data.push(Other);
	_backgroundColors.push('#efefef');
	_labels.push(otherLabel);


	// chartJS
	var config = {
		type: 'doughnut',
		data: {
			datasets: [{
				data: _data,
				backgroundColor: _backgroundColors,
				label: ''
			}],
			labels: _labels
		},
		options: {
			layout: {
				padding: 0
			},
			responsive: true,
			aspectRatio: 1.5,
			plugins: {
				legend: {
					display: false
				},
				title: {
					display: false
				}
			},
			animation: {
				animateScale: true,
				animateRotate: true
			}
		}
	};

	if (typeof (myDoughnut) != 'undefined')
		myDoughnut.destroy();

	var ctx = document.getElementById('chart-area').getContext("2d");
	myDoughnut = new Chart(ctx, config);
}